import React from 'react';

export type MeasureOptions = 'Callout' | 'Annotation' | 'Arrow' | 'Average' | 'Check' | 'Crossline' | 'Focusarrow' | 'Freeform' |
'Heart' | 'Horizontal' | 'Rectangle' | 'Star' | 'Vertical' | 'Xcross';

export const Measure: React.FunctionComponent<{selectedTool: MeasureOptions}> = ({ selectedTool }) => {
		return (
			<div>
				<span className="measureUnlit" id="mMeasure" />
			</div>
		);
};